var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayCollect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57586 8.50682H1.42813C0.865525 8.50682 0.405212 8.96713 0.405212 9.52973C0.405212 10.0923 0.865525 10.5526 1.42813 10.5526H7.57586V12.3837C7.57586 12.844 8.12823 13.069 8.44534 12.7417L11.289 9.88775C11.4834 9.68317 11.4834 9.36607 11.289 9.16148L8.44534 6.30755C8.12823 5.98021 7.57586 6.21548 7.57586 6.66557V8.50682ZM13.6929 6.24617V4.41515H19.8406C20.4032 4.41515 20.8635 3.95484 20.8635 3.39223C20.8635 2.82963 20.4032 2.36932 19.8406 2.36932H13.6929V0.538296C13.6929 0.0779839 13.1405 -0.147058 12.8234 0.180276L9.97971 3.03421C9.78536 3.2388 9.78536 3.5559 9.97971 3.76048L12.8234 6.61442C13.1405 6.93152 13.6929 6.70648 13.6929 6.24617Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayCollect);
export default __webpack_public_path__ + "static/media/pay-collect.d14527cb7b93ea007d9611b1954460be.svg";
export { ForwardRef as ReactComponent };